import VistaHome from "@/views/VistaHome.vue";

const home = {
  path: "/app/home",
  name: "home",
  component: VistaHome,
};

export default home;
